import React from 'react';

import {Point} from 'util/geometry/GeometryConstants';

export default function Line({
  startPoint,
  endPoint,
  stroke,
  strokeWidth,
  strokeDasharray,
  strokeLinecap,
}: {
  startPoint: Point;
  endPoint: Point;
  stroke: string;
  strokeWidth: number;
  strokeDasharray?: string;
  strokeLinecap?: 'butt' | 'round' | 'square' | 'inherit';
}): JSX.Element {
  return (
    <path
      d={['M', startPoint.x, startPoint.y, 'L', endPoint.x, endPoint.y].join(' ')}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeDasharray={strokeDasharray}
      strokeLinecap={strokeLinecap}
    />
  );
}
